define([
  "marionette",
  "messaging/messenger",
  "modules/shared/sortableList/sortableListModule",
  "./advancedConfigurationView",
  "./advancedConfigurationModel",
], function (
  Marionette,
  Messenger,
  SortableListModule,
  AdvancedConfigurationView,
  AdvancedConfigurationModel,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "kbAdvancedConfiguration";
      this.region = options.region;
      this.kb = options.model;
      this._setUpVents();
    },
    show: function () {
      this.advancedConfigurations = new AdvancedConfigurationModel.advancedConfigurations();
      this.advancedConfigurations.kbId = this.kb.get("kbId");
      this.advancedConfigurations.fetch();

      Messenger.onSave(() => {
        Messenger.reqres.request("save:textbox");
        this.advancedConfigurations.saveCollection();
      });

      this.layout = new AdvancedConfigurationView.layout({
        collection: this.advancedConfigurations,
      });
      this.layout.on("show", () => this._showSubViews());

      const headers = Messenger.reqres.request("kb:advancedConfiguration:headers");
      this.list = this.addSubModule(
        new SortableListModule({
          region: this.layout.list,
          headers: headers,
          doNotResetCollection: true,
          hideControls: true,
          namespace: this.name,
        }),
      );

      this.showRegion(this.layout);
    },
    _setUpVents: function () {
      Messenger.vent.on("show:kb:admin:advancedConfiguration", () => this.show());
      Messenger.vent.on("show:kb:profile:advancedConfiguration", () => this.show());
    },
    _showSubViews: function () {
      this.list.show(this.advancedConfigurations);
    },
  });
});
